import { render, staticRenderFns } from "./modalForm.vue?vue&type=template&id=0fdf87a6&scoped=true"
import script from "./modalForm.vue?vue&type=script&lang=js"
export * from "./modalForm.vue?vue&type=script&lang=js"
import style0 from "./modalForm.vue?vue&type=style&index=0&id=0fdf87a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf87a6",
  null
  
)

export default component.exports